import { GlobalState } from '../../actions';

const cacheSelector = (state: GlobalState) => state.cache;

export const cacheEntitySelector = (state: GlobalState, serverName: string) => {
    const serverState = cacheSelector(state)[serverName];
    return serverState ? serverState.caches : undefined;
}

export const cacheServerAvailableSelector = (state: GlobalState, serverName: string) => {
    const serverState = cacheSelector(state)[serverName];
    return serverState ? serverState.serverAvailable : undefined;
}